import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { AuthService } from '../services/auth/auth.service';
import { AuthStorageService } from '../services/auth/auth-storage.service';
import { SUPPORT_ENDED_URL } from '../services/support/support-paths';

export const publicGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const authStorage = inject(AuthStorageService);
  const router = inject(Router);

  if (!authService.isAuthenticated()) {
    // Pestaña en modo soporte cuya sesión ya no sirve: primero sale del modo
    // soporte (/support/ended). Un login acá quedaría guardado en la sesión de
    // soporte de la pestaña, bajo el banner de otra persona.
    if (authStorage.isSupportMode()) {
      return router.createUrlTree([SUPPORT_ENDED_URL], { queryParams: { reason: 'ended' } });
    }
    return true;
  }

  // Redirect to home if already authenticated. UrlTree (not router.navigate +
  // return false) avoids racing the navigation this guard is itself
  // resolving — see auth.guard.ts for the full rationale.
  return router.createUrlTree(['/home']);
};
